<template>
    <div class="basicInformation">
        <div class="common_group">
            <div class="title">
                <img src="@/assets/images/informationIcon.png">
                <span>{{ $t('newApp.Catalogue.t') }}</span>
            </div>
            <div class="common_readonly_template">
                <el-row>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                        <div>
                            <div class="label">{{ $t('newApp.Catalogue.zrs') }}</div>
                            <div class="text">{{ basicData.inviterNum }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                        <div>
                            <div class="label">{{ $t('newApp.Catalogue.dws') }}</div>
                            <div class="text">{{ basicData.invitedUnitNum }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                        <div>
                            <div class="label">{{ $t('newApp.Catalogue.create3m') }}</div>
                            <div class="text">{{ basicData.newOpptyNum }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                        <div>
                            <div class="label">{{ $t('newApp.Catalogue.push3m') }}</div>
                            <div class="text">{{ basicData.pushOpptyNum }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                        <div>
                            <div class="label">{{ $t('newApp.Catalogue.create3mAmount') }}</div>
                            <div class="text">{{ basicData.newOpptyAmount != null ? basicData.newOpptyAmount : 0 }}</div>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                        <div>
                            <div class="label">{{ $t('newApp.Catalogue.push3mAmount') }}</div>
                            <div class="text">{{ basicData.pushOpptyAmount != null ? basicData.pushOpptyAmount : 0 }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        editEchoData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            basicData: {},
            lang: localStorage.getItem('lang') || 'zh-CN'
        };
    },
    watch:{
        editEchoData: {
            handler(newVal) {
                this.basicData = {
                    ...newVal.marketActivity
                };
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.basicData = {
            ...this.editEchoData.marketActivity
        };
    }

}
</script>

<style lang="scss" scoped>
.activityBasicInformation {
    >.customerFileWrap {
        .table_file {
            >img {
                vertical-align: middle;
            }

            >span {
                margin-left: 10px;
                display: inline-block;
                vertical-align: middle;
            }
        }
    }

    >.activityDetailsFile,
    .activityDetailsCustomer {
        box-sizing: border-box;
        padding-left: 20px;
        padding-bottom: 50px;
        margin-top: 16px;

        >.title {
            font-size: 16px;
            font-weight: bold;
            margin: 3px 0 20px;
        }
    }
}
</style>